<template>
  <cv-button
    class="ff-button"
    @click="handleAction"
    :style="style"
    :pattern="pattern"
    :disabled="disabled"
    :class="{
      'is-default': !pattern || pattern === 0,
      'is-secondary': pattern === 2,
      'is-destructive': pattern === 3,
      'no-text': !text,
      'has-icon': icon
    }">
    <ph-eye class="ff-button__icon" v-if="icon === 'preview' || icon === 'eye'"/>
    <ph-sliders-horizontal class="ff-button__icon" v-if="icon === 'settings'"/>
    <ph-currency-circle-dollar class="ff-button__icon" v-if="icon === 'payments'"/>
    <ph-user-circle-gear class="ff-button__icon" v-if="icon === 'fans'"/>
    <ph-pencil-line class="ff-button__icon" v-if="icon === 'edit'"/>
    <ph-x-circle class="ff-button__icon" v-if="icon === 'close'"/>
    <ph-download class="ff-button__icon" v-if="icon === 'download'"/>
    <ph-lock-key class="ff-button__icon" v-if="icon === 'lock'"/>
    <ph-share class="ff-button__icon" v-if="icon === 'share'"/>
    <ph-dots-three-outline-vertical class="ff-button__icon" v-if="icon === 'overflow'"/>
    {{text}}
  </cv-button>
</template>

<script>
import {
  PhEye,
  PhSlidersHorizontal,
  PhCurrencyCircleDollar,
  PhDotsThreeOutlineVertical,
  PhUserCircleGear,
  PhLockKey,
  PhPencilLine,
  PhXCircle,
  PhShare,
  PhDownload
} from "phosphor-vue";

export default {
  name: 'ff-button',
  props: [
    'action',
    'text',
    'options',
    'pattern',
    'disabled',
    'icon'
  ],
  components: {
    PhEye,
    PhSlidersHorizontal,
    PhCurrencyCircleDollar,
    PhDotsThreeOutlineVertical,
    PhUserCircleGear,
    PhLockKey,
    PhXCircle,
    PhShare,
    PhPencilLine,
    PhDownload
  },
  data () {
    return {
    }
  },
  computed: {
    style () {
      if (!this.options) return
      let s = {}
      if (this.options.width === 100) {
        s.width = '100%'
      }
      if (this.options.backgroundColor) {
        s.backgroundColor = this.options.backgroundColor
      }
      return s
    }
  },
  provide: {
    size: 18
  },
  methods: {
    handleAction (e) {
      if (this.action) return this.action(e)
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .ff-button {
    min-height: 34px;
    @include button;

    &.has-icon {
      position: relative;
      padding-left: $unit-3;
      display: block;
    }

    &__icon {
      width: 18px;
      height: 18px;
      display: inline-block;
      position: absolute;
      left: 11px;
      bottom: 8px;
    }

    svg {
      pointer-events: none;
    }
  }

  .is-default {
    @include button;
    background: $color-main;
  }

  .is-secondary {
    @include button;
    background: transparent;
    color: $color-dark;

    &:hover {
      background: $color-almost-white;
      color: $color-dark;
    }

    &:active,
    &:focus {
      background: $color-main;
      color: $color-white;
    }
  }

  .is-destructive {
    @include button;
    background: $color-fail;

    &:hover {
      background: darken($color-fail, 10%);
    }
  }

  .is-disabled {
    cursor: not-allowed;
    background: $color-demure;

    &:focus {
      border-color: transparent;
      box-shadow: none;
    }

    &:hover {
      cursor: not-allowed;
      background: $color-demure;
    }
  }

  .no-text {
    &.ff-button.has-icon {
      padding: 0;
      width: 34px;
      height: 34px;
      font-size: 1rem;
    }
    .ff-button__icon {
      left: 7px;
      bottom: 7px;
    }
  }

</style>
